module.exports = __webpack_public_path__ + "static/OG_DigirytePods-322b512fef562ebdfffa4114c1e0d82e.jpg";